import React from "react";

const sizes = { xs: 24, sm: 32, md: 40, lg: 56, xl: 96 };

export function Avatar({ src, name = "", size = "md", shape = "circle", style = {} }) {
  const dim = typeof size === "number" ? size : sizes[size];
  const initial = (name || "?").charAt(0).toUpperCase();
  const radius = shape === "circle" ? "var(--radius-pill)" : "var(--radius-md)";
  if (src) {
    return <img src={src} alt="" width={dim} height={dim}
      style={{ borderRadius: radius, objectFit: "cover", background: "var(--sand)", flex: "0 0 auto", ...style }} />;
  }
  return (
    <span style={{
      width: dim, height: dim, borderRadius: radius, flex: "0 0 auto",
      display: "inline-flex", alignItems: "center", justifyContent: "center",
      background: "var(--hive)", color: "var(--text-on-primary)",
      fontFamily: "var(--font-display)", fontWeight: "var(--weight-bold)",
      fontSize: Math.round(dim * 0.42), ...style,
    }}>{initial}</span>
  );
}
